import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { get } from 'lodash';
import { toast } from 'react-toastify';

const onError = (error: ExpectedAny, query: ExpectedAny) => {
  if (!query?.meta?.ignoreError) {
    console.error(error.message);
  }
};
const onErrorMutation = (error: Error, query: ExpectedAny) => {
  const message = get(error, 'response.data.message') ?? 'Something went wrong! Please try again.'
  toast.error(message)
};


const queryCache: ExpectedAny = new QueryCache({
  onError,
});

const mutationCache: ExpectedAny = new MutationCache({
  onError: onErrorMutation,
});

export const queryClient: QueryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24,
    }
  }
});
